// LatencyTile.js — per-call decision-engine p95 latency over the window.
// Reads call_metrics (one doc per completed call, p95 already computed
// per-call in server.py:save_call_metrics from each call's turns). Shows
// median-of-p95 (the typical call's p95) and worst-of-p95 (the outlier).

import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useLatencyP95Stats } from '../../../hooks/useAdminMetrics';

const LatencyTile = ({ days = 7 }) => {
  const { medianP95Ms, maxP95Ms, sampleSize, loading, error } = useLatencyP95Stats(days);

  if (error) {
    return (
      <Card><CardContent>
        <Typography color="error">Latency unavailable: {error.message}</Typography>
      </CardContent></Card>
    );
  }

  const fmtMs = (n) => `${n.toLocaleString()}ms`;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>Decision Latency p95 ({days}d)</Typography>
        {loading ? (
          <Typography variant="h3">…</Typography>
        ) : sampleSize === 0 ? (
          <Typography variant="body2" color="text.secondary">No call_metrics in window.</Typography>
        ) : (
          <Box sx={{ display: 'flex', gap: 4 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">Typical (median of p95)</Typography>
              <Typography variant="h3">{fmtMs(medianP95Ms)}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Worst</Typography>
              <Typography variant="h4">{fmtMs(maxP95Ms)}</Typography>
            </Box>
          </Box>
        )}
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          Per-call p95 of the decision engine's per-turn latency, aggregated across {sampleSize.toLocaleString()} call{sampleSize === 1 ? '' : 's'}.
          "Typical" is the median p95 across calls; "Worst" is the highest p95.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default LatencyTile;
